<template>
    <div class="my-orders">
        <h3 class="mb-3">My Orders</h3>

        <div v-if="!allOrders">
            <content-placeholders>
                <content-placeholders-text :lines="5" />
            </content-placeholders>
        </div>
        <b-tabs content-class="mt-3" v-else>
            <b-tab title="My Orders">
                <div v-if="allOrders && allOrders.length">
                    <OrderCollection :orders="allOrders" />
                </div>
                <div v-else class="alert alert-danger">
                    <!-- 0 orders -->
                    You do not have any orders.
                </div>
            </b-tab>
            <b-tab title="Pending" v-if="pendingOrders && pendingOrders.length">
                <div v-if="pendingOrders && pendingOrders.length">
                    <OrderCollection :orders="pendingOrders" />
                </div>
                <div v-else class="alert alert-danger">
                    <!-- 0 orders -->
                    You do not have any pending orders.
                </div>
            </b-tab>
            <b-tab v-for="(ordersData, index) in customerRolesWithView" :title="`${customers[ordersData.customer_id].name} Orders`" v-if="customers && customerOrders.length">
                <div v-if="ordersData.orders.length">
                    <OrderCollection :orders="ordersData.orders" />
                </div>
                <div v-else class="alert alert-danger">
                    <!-- 0 orders -->
                    There are no orders for this organization.
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>

import OrderDetails from "@/components/dashboard/OrderDetails.vue";
import OrderCollection from "@/components/dashboard/OrderCollection";
import {mapState} from "vuex";

export default {
    components: {
        OrderCollection,
        Order: OrderDetails
    },
    data: () => ({
    }),
    computed: {
        ...mapState({
            allOrders: state => state.dashboard.myOrders,
            pendingOrders: state => state.dashboard.pendingOrders,
            customerOrders: state => state.dashboard.userCustomers,
            customers: state => state.dashboard.customers,
        }),
        customerRolesWithView() {
            let user = this.$auth.user();
            console.log(this.customerOrders);
            let orders = this.customerOrders.filter(function (customerOrderData) {
                let role = user.customer_roles.find(role => role.customer_id == customerOrderData.customer_id);
                console.log(role);
                return role.permission == 'edit' || role.permission == 'admin' || role.permission == 'view';
            });
            console.log(orders);
            return orders;
        },
    },
    created() {
    },
    methods: {
    }
}
</script>


<style lang="scss" scoped>
.order + .order {
    margin-top: .25rem;
}
.order .card-header {
    cursor: pointer;
}
// .order:nth-child(even) .card-header {
//         background-color: rgba(0, 0, 0, 0.06);
// }
.caret-up {
    display: inline-block;
}
.collapsed .caret-up {
    display: none;
}
.caret-down {
    display: none;
}
.collapsed .caret-down {
    display: inline-block;
}

.order.large .table-responsive {
    max-height: 283px;
    overflow: scroll;
}

.order.large .table-responsive::-webkit-scrollbar {
    -webkit-appearance: none;
}

.order.large .table-responsive::-webkit-scrollbar:vertical {
    width: 11px;
}

.order.large .table-responsive::-webkit-scrollbar:horizontal {
    height: 11px;
}

.order.large .table-responsive::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
}
</style>

